import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { createSwitch } from '@/utils'
import { Content, Trigger } from './components'

interface Props {
  onChange: (value: boolean) => void
  value: boolean
}

export const ShowResolvedToggle: React.FC<Props> = ({ onChange, value }) => {
  const switcher = createSwitch().case(['show_resolved'], () =>
    onChange(!value)
  )

  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <DropdownMenu.Root
      align="end"
      onClick={onClick}
      content={Content}
      value={value}
    >
      <Trigger />
    </DropdownMenu.Root>
  )
}
